import { Link } from "react-router-dom";
import { categories } from "@/mocks/movies";
import { movies } from "@/lib/movies";
import type { CategoryItem } from "@/types/movie";

const items = categories as unknown as CategoryItem[];

export default function CategoryGrid() {
  return (
    <section className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      {items.map((cat) => {
        const count = movies.filter((m) => m.type === cat.key).length;
        return (
          <Link
            key={cat.key}
            to={`/category/${cat.key}`}
            className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${cat.icon} text-2xl`} />
            </span>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
              {cat.label}
            </h3>
            <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">
              {cat.desc}
            </p>
            <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-accent-600">
              {count} 部作品
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
            </span>
          </Link>
        );
      })}
    </section>
  );
}